export default __webpack_public_path__ + "static/media/slide2.c70efe14.jpg";